import { z } from 'zod'
import { KpiTierEnumValues } from '@forgd/shared/rfq/calculations/kpi-calculator'

export const KpiResultSchema = z.object({
  tier: z.enum(KpiTierEnumValues),
  loanValueDepth50Bps: z.number().positive().finite().safe(),
  loanValueDepth100Bps: z.number().positive().finite().safe(),
  loanValueDepth200Bps: z.number().positive().finite().safe(),
  bidAskSpreadBps: z.number().positive().finite().safe(),
})

export const BasicKpiResultSchema = z.object({
  bidAskSpreadTarget: z.number().positive().finite().safe(),
  depth50Target: z.number().positive().finite().safe(),
  depth100Target: z.number().positive().finite().safe(),
  depth200Target: z.number().positive().finite().safe(),
})

export type KpiResult = z.infer<typeof KpiResultSchema>
export type BasicKpiResult = z.infer<typeof BasicKpiResultSchema>
